import Alpine from '@alpinejs/csp';
import './htmx';
import { startStoreServerTimestampUpdate } from "@core/js/server-time";
import { startSSE } from "@core/js/sse";

import Lot from "@core/js/widgets/lot";

import siteNavigation from './widgets/site-navigation';
import languageSwitcher from './widgets/language-switcher';
import cookieBanner from './widgets/cookie-banner';
import dismissible from './widgets/dismissible';
import disclosure from './widgets/disclosure';
import serverClock from './widgets/server-clock';
import sseStatus from './widgets/sse-status';
import browserNavigationWarning from './widgets/browser-navigation-warning';
import { startBrowserNavigationProtection } from './browser-navigation';

// Register Alpine components
Alpine.data('Lot', Lot);
Alpine.data('SiteNavigation', siteNavigation);
Alpine.data('LanguageSwitcher', languageSwitcher);
Alpine.data('CookieBanner', cookieBanner);
Alpine.data('Dismissible', dismissible);
Alpine.data('Disclosure', disclosure);
Alpine.data('ServerClock', serverClock);
Alpine.data('SSEStatus', sseStatus);
Alpine.data('BrowserNavigationWarning', browserNavigationWarning);

startStoreServerTimestampUpdate();
startBrowserNavigationProtection();
startSSE();

window.Alpine = Alpine;
Alpine.start();
